import {
  AREA_OF_CONCERN,
  RESTORATIVE_ADJACENT_LUCENCY,
} from '../../../../constants';

export const displayFindingList = (
  groupType: string,
  cariesSubclassEnabled: boolean,
  vdaEnabled: boolean,
) => {
  if (groupType === AREA_OF_CONCERN) {
    return cariesSubclassEnabled;
  }
  if (groupType === RESTORATIVE_ADJACENT_LUCENCY) {
    return vdaEnabled;
  }
  return true;
};
